export const requestPermission = async (permissions: PermissionKey[]): Promise<void> => {
    try {
        if (window.ReactNativeWebView) {
            await window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    action: "permissionRequest",
                    permissions,
                })
            );
        } else {
            console.warn("ReactNativeWebView not found");
        }
    } catch (error) {
        console.error("Failed to request permissions:", error);
    }
};
type PermissionKey =
    | 'camera'
    | 'mic'
    | 'storage'
    | 'images'
    | 'video'
    | 'notification'; 